define(function (require) {
    var $ = require("jquery");
    var confirmExitDialog = false;
    if (window.scan && window.scan.exitDialogMessage) {
        window.onbeforeunload = function () {
            if (!confirmExitDialog) {
                return window.scan.exitDialogMessage;
            };
        };

        $("a, button").click(function() {
            confirmExitDialog = true;
        });
    }
});
